import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

import {isDefined} from '../../typecheck';

/**
 * Check if a course is corporate,
 * means it has been created based on a program that created based on corporate offer
 * (employer/employee courses)
 */
export const isCourseCorporate = (course?: Nullable<CourseApiModel>) => {
  return isDefined(course?.subtenant_id);
};
